<template>
  <card class="card">
    <div class="questions-list__question pt-4">
      <div v-if="answerCopy">
        <div v-if="!answerCopy.skipped">
          <div v-if="checkIfSeeAllQuestionnaire()" class="questions-list__question-score">
            <span> Score </span> {{ score }} / {{ question.question_weight }}
          </div>
          <div
            v-else
            class="questions-list__question-score"
            :class="scoreColorStyle(score / question.question_weight, answerCopy)"
          >
            <span> Score </span> {{ Math.round((score / question.question_weight) * 100) }}%
          </div>
          <div class="row">
            <div class="col-6">
              <div class="questions-list__question-text">{{ question.question_text }}</div>
            </div>
            <div class="col">
              <AnswerField
                :question="question"
                :answer="answerCopy"
                :company="company"
                @saved="calcScore($event)"
              ></AnswerField>
            </div>
            <div class="col">
              <div v-if="checkIfSeeAllQuestionnaire()" class="questions-list__question-buttons text-primary">
                <p-button
                  outline
                  icon
                  type="info"
                  @click.prevent.native="reset()"
                  class="questions-list__question-button"
                >
                  <i class="fas fa-sync-alt" />
                </p-button>
                <p-button
                  v-if="question.can_be_skipped === '1'"
                  outline
                  icon
                  type="danger"
                  @click.prevent.native="skip()"
                  class="questions-list__question-button"
                >
                  <i class="fas fa-times" />
                </p-button>
                <FavoriteButton :answer="answerCopy" :question="question" :company="company"></FavoriteButton>
              </div>
              <div v-else class="questions-list__question-buttons text-primary">
                <FavoriteButton :answer="answerCopy" :question="question" :company="company"></FavoriteButton>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="row">
          <div class="col">
            <div class="questions-list__question-text--skipped">{{ question.question_text }}</div>
          </div>
          <div class="col">
            <p-button outline icon class="questions-list__question-button--show" @click.native.prevent="show()">
              <i class="fas fa-arrow-down" />
            </p-button>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import QuestionAnswerController from '../../controllers/QuestionAnswer/QuestionAnswerController';
import SkipCompanyAnswerController from '../../controllers/QuestionAnswer/SkipCompanyAnswerController';
import ScoreController from '@/controllers/Score/ScoreController';
import AnswerField from '@/components/Questions/AnswerField';
import checkIfCanSeeQuestionnaire from '@/router/scopes/questionnaire/CheckIfCanSeeQuestionnaire';
import FavoriteButton from '@/components/buttons/FavoriteButton';

export default {
  name: 'Question',
  components: { FavoriteButton, AnswerField },
  props: {
    question: {
      type: Object,
    },
    company: {
      type: Object,
    },
    answer: {
      type: Object,
    },
    QuestionIndex: {},
  },
  data() {
    return {
      score: 0,
      answerCopy: null,
    };
  },
  watch: {
    answer(NewVal) {
      this.setData(NewVal);
    },
  },
  async created() {
    await this.setData(this.answer);
  },
  methods: {
    async reset() {
      this.answerCopy = Object.assign({}, this.answerCopy, { value: null });
      try {
        await QuestionAnswerController.destroy(this.answerCopy.id);
        await this.calcScore(this.answerCopy.value);
        this.$notify({
          type: 'success',
          title: 'Saved!',
        });
      } catch (error) {
        console.error(error);
        this.$notify({
          type: 'danger',
          title: 'Was not saved!',
        });
      }
    },
    skip() {
      this.answerCopy = Object.assign({}, this.answerCopy, { skipped: true });
      this.changeSkipped(this.answerCopy.skipped);
    },
    show() {
      this.answerCopy = Object.assign({}, this.answerCopy, { skipped: false });
      this.changeSkipped(this.answerCopy.skipped);
    },
    changeSkipped(newVal) {
      let vm = this;
      delay(function () {
        try {
          SkipCompanyAnswerController.store({
            question_id: vm.question.id,
            related_to: vm.company.company_id,
            skipped: newVal,
          });
          vm.$notify({
            type: 'success',
            title: 'Saved!',
          });
        } catch (error) {
          vm.$notify({
            type: 'danger',
            title: 'Was not saved!',
          });
        }
      }, 500);
    },
    async calcScore(value) {
      this.score = await ScoreController.calculateScore(value, this.question);
      this.setAnswerValue(value);
      return this.score;
    },
    setAnswerValue(value) {
      this.answerCopy.value = value;
      this.answerCopy.achieved_weight = this.score;
    },
    setData(answer) {
      this.answerCopy = answer;
      this.calcScore(this.answerCopy.value);
    },
    checkIfSeeAllQuestionnaire() {
      return checkIfCanSeeQuestionnaire();
    },
    scoreColorStyle(score_percent, answer) {
      return ScoreController.scoreColorStyle(score_percent, answer);
    },
  },
};

let delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
</script>

<style scoped></style>
